import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';

import { dropdownOptionStyles } from './menu';

declare module '@mui/material/Autocomplete' {
  interface AutocompletePropsSizeOverrides {
    large: true;
  }
}

function NoOptionsText() {
  const { t } = useTranslation();
  return <>{t('choices_select.empty', 'No options')}</>;
}

const autocomplete = {
  MuiAutocomplete: {
    defaultProps: {
      popupIcon: <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />,
      noOptionsText: <NoOptionsText />,
    },
    styleOverrides: {
      root: {
        'label + & .MuiInputBase-root': {
          marginTop: '18px',
        },
        '& .MuiAutocomplete-endAdornment': {
          paddingRight: '7px',
        },
      },
      inputRoot: {
        padding: '0 10px',
      },
      clearIndicator: {
        padding: '3px',
        '& .MuiSvgIcon-root': {
          fontSize: 16,
        },
      },
      listbox: {
        '& .MuiAutocomplete-option': {
          ...dropdownOptionStyles,
        },
      },
    },
  },
};

export default autocomplete;
